module.exports = __webpack_public_path__ + "img/tech_map.03382d07.svg";